import _head from "lodash/head";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@nextiva/next-ui';
import { NULL } from "../../../constants";
import ColumnFilter from "../ColumnFilter";
import { mapNullValues } from "../dataMappers/incoming";
import { formatNullValues } from "../dataMappers/outgoing";

var UniqueColumn =
/*#__PURE__*/
function (_Component) {
  _inherits(UniqueColumn, _Component);

  function UniqueColumn() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, UniqueColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = UniqueColumn.__proto__ || Object.getPrototypeOf(UniqueColumn)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "handleFilterChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(_ref2) {
        var _value = _ref2.value;

        _this.props.onFilterChange([_value]);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderPicker", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            options = _this$props.options,
            values = _this$props.values,
            type = _this$props.type,
            onSelectFocus = _this$props.onSelectFocus,
            typeConfig = _this$props.typeConfig,
            portalWrapperClass = _this$props.portalWrapperClass;

        var value = _head(values);

        var filterOptions;

        if (type === 'boolean') {
          filterOptions = [{
            value: true,
            label: 'True'
          }, {
            value: false,
            label: 'False'
          }];
        } else {
          filterOptions = options.map(function (item) {
            return {
              value: item.value,
              label: item.label || item.value
            };
          });
        }

        if (!typeConfig.disableNullOption) {
          filterOptions.push({
            label: 'None',
            value: NULL
          });
        }

        return React.createElement("div", {
          className: "nx-filter-column__search"
        }, React.createElement(Select, {
          searchable: true,
          options: filterOptions,
          value: value,
          onChange: _this.handleFilterChange,
          onFocus: onSelectFocus,
          portalMenuWrapperClassName: portalWrapperClass
        }));
      }
    }), _temp));
  }

  _createClass(UniqueColumn, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          operator = _props.operator,
          operatorOptions = _props.operatorOptions,
          onOperatorChange = _props.onOperatorChange,
          onSelectFocus = _props.onSelectFocus;
      return React.createElement(ColumnFilter, {
        onOperatorChange: onOperatorChange,
        options: operatorOptions,
        operator: operator,
        onFocus: onSelectFocus
      }, this.renderPicker());
    }
  }]);

  return UniqueColumn;
}(Component);

Object.defineProperty(UniqueColumn, "defaultOperator", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return 'eq';
  }
});
Object.defineProperty(UniqueColumn, "getOperatorOptions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(_ref3) {
    var _ref3$title = _ref3.title,
        title = _ref3$title === void 0 ? 'Value' : _ref3$title;
    return [{
      value: 'eq',
      label: "".concat(title, " is")
    }, {
      value: 'neq',
      label: "".concat(title, " is not")
    }];
  }
});
Object.defineProperty(UniqueColumn, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    values: PropTypes.array,
    operator: PropTypes.string,
    operatorOptions: PropTypes.array,
    onOperatorChange: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    isNullTypeOperator: PropTypes.bool,
    options: PropTypes.array,
    onSelectFocus: PropTypes.func,
    typeConfig: PropTypes.object
  }
});
Object.defineProperty(UniqueColumn, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    typeConfig: {}
  }
});
Object.defineProperty(UniqueColumn, "mapIncomingFilters", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: mapNullValues
});
Object.defineProperty(UniqueColumn, "mapOutgoingFilters", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: formatNullValues
});
export default UniqueColumn;